import React, { useEffect, useState } from "react";
import CardLoading from "../../../../components/CardLoading";
import { fetchData } from "../../../../features/dropdown/dropdownSlice";
import { Checkbox, Divider, Dropdown, Table, Tag } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Search from "../../../../components/Search";
import svg77 from "../../../../assets/svg/svg77.svg";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import ConfirmModal from "../../../../components/ConfirmModal";
import ProfileView from "../recommendation/ProfileView";
import svg86 from "../../../../assets/svg/svg86.svg";
import svg82 from "../../../../assets/svg/svg82.svg";
import svg80 from "../../../../assets/svg/svg80.svg";
import svg27 from "../../../../assets/svg/svg27.svg";
import svg79 from "../../../../assets/svg/svg79.svg";
import { capitalize, formatText } from "../../../../utils";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import InterviewResult from "./modal/InterviewResult";

function Candidates() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v1/applications/filter";
  const { loading, data, count, activeObjJob } = useSelector((state) => ({
    loading: state.dropdown.loading,
    data: state.dropdown.data[url] || [],
    count: state.dropdown.count[url] || 0,
    activeObjJob: state.folder.activeObj["job"],
  }));

  const { open, handleCancel, handleOpen } = useModalToggle();
  const { refetchKey } = useSelector((state) => state.folder);

  const showDrawer = () => {
    handleOpen();
  };
  const onClose = () => {
    handleCancel();
  };

  const { saving } = useSelector((state) => state.save);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState();
  const handleOpenAction = async (item) => {
    await setSelectedStatus(item);
    await setContent(
      `Are you sure you want to ${formatText(item)} ${prodd?.japFirstName} ${
        prodd?.japLastName
      }`
    );
    await setOpenDelete(true);
  };
  const handleCloseAction = async () => {
    await setOpenDelete(false);
  };
  const [content, setContent] = useState();
  const handleAction = async () => {
    const res = await dispatch(
      save({
        url: "api/v1/applications/create",
        japProgressStatus: selectedStatus.toUpperCase(),
        japId: prodd?.japId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const [openMarks, setOpenMarks] = useState(false);
  const handleOpenMarks = async (item) => {
    await setSelectedStatus(item);
    await setOpenMarks(true);
  };
  const handleCloseMarks = async () => {
    await setOpenMarks(false);
  };

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        japFirstName: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const statusMap = {
    Submitted: { value: "DRAFT", label: "Submitted" },
    Shortlisted: { value: "SHORTLIST", label: "Shortlisted" },
    Scheduled_Interview: {
      value: "SCHEDULE_INTERVIEW",
      label: "Scheduled_Interview",
    },
    Offer: { value: "OFFER", label: "Offer" },
    Hired: { value: "HIRE", label: "Hired" },
    Dropped: { value: "DROP", label: "Dropped" },
    Drop: { value: "DROP", label: "Dropped" },
    Hire: { value: "HIRE", label: "Hired" },
    Shortlist: { value: "SHORTLIST", label: "Shortlisted" },
    "Interview Results": {
      value: "INTERVIEW_RESULT",
      label: "Interview_Result",
    },
  };

  const plainOptions = activeObjJob?.jobRecruitmentProcess
    ?.map((status) => statusMap[status])
    ?.filter(Boolean);

  const [selectedFilters, setSelectedFilters] = useState([]);
  const [popoverVisible, setPopoverVisible] = useState(false);

  const handleRemoveFilter = (removedStatus) => (e) => {
    e.preventDefault();
    setSelectedFilters((prev) =>
      prev?.filter((status) => status !== removedStatus)
    );
  };
  const onChangeFilter = (checkedValues) => {
    setSelectedFilters(checkedValues);
  };

  const handleApply = async () => {
    await setPopoverVisible(false);
  };

  const handleReset = async () => {
    await setSelectedFilters([]);
    await setPopoverVisible(false);
  };
  const filterOverlay = (
    <div className="w-[15.6875rem] p-[1.5rem] bg-white rounded-[.5rem] shadow-[0_0_13.9px_0_rgba(0,0,0,0.08)]">
      <p className="font-semibold">Select Filter</p>
      <Checkbox.Group
        options={plainOptions}
        value={selectedFilters}
        onChange={onChangeFilter}
        className="filter-checkbox"
      />

      <Divider />

      <div className="flex justify-center gap-[1.5rem] mt-3 font-dmSans text-[.875rem] font-[400]">
        <span className="text-[#FDB505]  cursor-pointer" onClick={handleReset}>
          Reset
        </span>
        <span className="text-[#C62130]  cursor-pointer" onClick={handleApply}>
          Apply
        </span>
      </div>
    </div>
  );

  const handleViewName = async (item) => {
    await setProdd(item);
    await showDrawer();
  };

  const iconsMap = {
    Shortlist: svg80,
    Schedule_Interview: svg86,
    Offer: svg82,
    Hire: svg82,
    Drop: svg82,
    "Interview Results": svg80,
  };

  const labelMap = {
    Shortlist: "Shortlist",
    Schedule_Interview: "Schedule Interview",
    Offer: "Offer",
    Hire: "Hire",
    Drop: "Drop",
    "Interview Results": "Interview Results",
  };

  const desiredOrder = [
    "Shortlist",
    "Interview Results",
    "Offer",
    "Hire",
    "Drop",
  ];

  const buildMenuItems = (steps) => {
    const sortedSteps = [...(steps || [])].sort(
      (a, b) => desiredOrder?.indexOf(a) - desiredOrder?.indexOf(b)
    );

    return sortedSteps?.flatMap((step, index) => {
      const stepKey = index + 1;

      const onClickHandler =
        step === "Interview Results"
          ? () => handleOpenMarks(step)
          : () => handleOpenAction(step);

      return [
        {
          key: String(stepKey),
          label: (
            <Link
              className="flex gap-x-[.75rem] items-center py-[.5rem]"
              onClick={onClickHandler}
            >
              <img src={iconsMap[step]} alt={step} className="w-4 h-4" />
              <span className="whitespace-nowrap">{labelMap[step]}</span>
            </Link>
          ),
        },
        index < sortedSteps?.length - 1 && {
          key: `divider-${stepKey}`,
          type: "divider",
        },
      ]?.filter(Boolean);
    });
  };

  const settingItems = buildMenuItems(activeObjJob?.jobRecruitmentProcess);

  const settingItemsBulk = buildMenuItems(activeObjJob?.jobRecruitmentProcess);

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "3%",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Candidate",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.japFirstName} {item?.japLastName}
          </div>
        );
      },
    },

    {
      title: "Match Score",
      dataIndex: "japMatchingScore",
      render: (item) => {
        return (
          <div className="py-[.25rem] px-[.5rem] flex items-center justify-center gap-[.625rem] rounded-[.25rem] bg-[#569D6E] opacity-[0.8]">
            {item}
          </div>
        );
      },
    }, 
    {
      title: "Interview Score (%)",
      dataIndex: "japInterviewScore",
    },
 
    {
      title: "Progress Status",
      dataIndex: "japProgressStatus",
      render: (item) => {
        const colors = {
          DRAFT: "#706F6F",
          SHORTLIST: "#FDB505",
          SCHEDULE_INTERVIEW: "#DAA520",
          OFFER: "#569D6E",
          HIRE: "#569D6E",
          DROP: "#C62130",
        };

        return (
          <div
            className="bg-[#E8EEED] inline-block rounded-[8px] px-[1rem] py-[.25rem] w-auto !font-[500] !text-[1rem]"
            style={{
              color: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [rowId, setRowId] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const handleEmployeeToReturns = async (selectedRows) => {
    await setRowId(selectedRows);
    // await showModalGroup();
  };

  const onSelectChange = (keys, rows) => {
    setSelectedRowKeys(keys);
    handleEmployeeToReturns(rows);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        jobId: activeObjJob?.jobId,
        progressStatuses: selectedFilters,
      })
    );
  }

  useEffect(() => {
    if (refetchKey == 4) {
      fetchTableData();
    }
  }, [refetchKey, selectedFilters]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-[1rem]">
          <div className="lg:w-[35.125rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search ..."}
            />
          </div>

          <Dropdown
            overlay={filterOverlay}
            trigger={["click"]}
            placement="bottom"
            open={popoverVisible}
            onOpenChange={(visible) => setPopoverVisible(visible)}
          >
            <div className="flex items-center cursor-pointer text-[#706F6F] text-[.875rem] font-[400] font-dmSans">
              <span>Filter</span>
              <img src={svg77} alt="filter icon" className="ml-1" />
            </div>
          </Dropdown>
        </div>

        {rowId?.length > 0 && (
          <Dropdown
            overlayStyle={{
              width: "200px",
            }}
            trigger={"click"}
            menu={{ items: settingItemsBulk }}
            placement="bottom"
          >
            <button
              className="min-w-[7.0625rem]  py-0 px-[.75rem] gap-[.5rem] rounded-[1.625rem] border border-[#0B363D] bg-[#F9F9F9] flex items-center min-h-[2.5rem]"
              type="button"
            >
              Bulk Actions
              <img src={svg79} alt="svg79" />
            </button>
          </Dropdown>
        )}
      </div>
      <div className="mt-[1.25rem]">
        {selectedFilters &&
          selectedFilters?.map((status) => {
            const matchedOption = plainOptions?.find(
              (opt) => opt?.value === status
            );
            const label = matchedOption ? matchedOption.label : status;

            const statusColors = {
              Submitted: "#706F6F",
              Shortlisted: "#FDB505",
              Scheduled_Interview: "#DAA520",
              Offer: "#569D6E",
              Hired: "#569D6E",
              Dropped: "#C62130",
            };

            return (
              <Tag
                closeIcon
                onClose={handleRemoveFilter(status)}
                className="inline-block w-fit max-w-max px-[.5rem] py-[.25rem] bg-[#E8EEED]
                        rounded-[2.1875rem] text-[.75rem] font-[400]"
                style={{ color: statusColors[label] || "#000" }}
              >
                {label}
              </Tag>
            );
          })}
      </div>

      <Table
        rowSelection={rowSelection}
        className="mt-[2.5rem] w-full"
        scroll={{
          x: "auto",
        }}
        rowKey={(record) => record?.japId}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          position: ["bottomRight"],
          current: pageIndex + 1,
          total: count,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPageIndex(page - 1);
            setPageSize(size);
            fetchTableData(page - 1, size);
          },
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
      />
      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseAction}
        handleSubmit={handleAction}
        loading={saving}
        content={content}
        type="info"
        btnTitle="Confirm"
      />

      <InterviewResult
        open={openMarks}
        handleCancel={handleCloseMarks}
        handleFetch={fetchTableData}
        title={`Interview Results for ${prodd?.japFirstName} ${prodd?.japLastName}`}
        prodd={prodd}
        onClose={onClose}
      />
      <ProfileView
        onClose={onClose}
        openDrawer={open}
        prodd={prodd}
        action={true}
        handleFetch={fetchTableData}
      />
    </>
  );
}

export default Candidates;
